module.exports = __webpack_public_path__ + "img/bg.c19e8efb.png";